import React, { useMemo } from "react";
import AuthCheck from "@swiggy-private/generic-mxn-ui/dist/2fa";
import { useRouter } from "next/router";

const AuthCheckPage = () => {
    const router = useRouter();
    const otp = router?.query?.o as string;

    const decodedOtp = useMemo(() => {
        try {
            return otp ? atob(otp) : "";
        } catch (error) {
            throw new Error(`Error decoding OTP: ${error}`);
        }
    }, [otp]);

    return (
        <>
            <AuthCheck decodedOtp={decodedOtp} />
            <script
                id="inline-nr-traffic-2fa-log"
                dangerouslySetInnerHTML={{
                    __html: `
                window.__NR_ENDPOINT__ = "https://insights-collector.newrelic.com/v1/accounts/737486/events";
                window.__NR_KEY__ = "CPDMQSXvjxGCdL_E02P9eZ-NJcEg-uGk";
                function sendNREvent(event) {
                    if (typeof window === "undefined" || typeof fetch === "undefined") return;
                    var endpoint = window.__NR_ENDPOINT__ || "";
                    var key = window.__NR_KEY__;
                    try {
                        const eventToSend = Object.assign({}, {
                            href: window.location.href,
                            userAgent: window.navigator.userAgent,
                        }, event);
                        if(endpoint && key){
                            fetch(endpoint, {
                                method: "POST",
                                mode: "cors",
                                headers: {
                                    "X-Insert-Key": key || "",
                                    "Content-Type": "application/json",
                                },
                                body: JSON.stringify(eventToSend),
                            }).catch(function(){ });
                        }
                    } catch (err) {
                        console.error(err);
                    }
                }
                sendNREvent({eventType: "STATIC_PAGE_2FA_LOAD_EVENT"});
            `,
                }}
            />
        </>
    );
};

export default AuthCheckPage;
